﻿/* lg-mega-hover.js v3.1 — per-item panes in the unified sheet.
  Hover behaviour is unchanged. Keyboard: focus opens the matching pane,
  ArrowDown/Tab from the trigger moves into it. Escape closes only when
  focus is inside the open pane, then restores the trigger without
  reopening. [hidden] and aria-expanded stay in sync with .lg-mega-open. */
(function () {
  if (!window.matchMedia('(min-width: 990px) and (hover: hover)').matches) return;

  function init() {
    var navList = document.querySelector('.header__inline-menu ul');
    var panel = document.getElementById('LgMegaPanel');
    if (!navList || !panel) return;

    var wrap = panel.closest('.shopify-section') || panel;
    wrap.style.position = 'fixed';
    wrap.style.left = '0';
    wrap.style.right = '0';
    wrap.style.zIndex = '60';

    var panes = panel.querySelectorAll('.lg-mega__pane');
    var closeTimer = null;
    var keepOpen = false;
    var activeIndex = -1;
    var lastTrigger = null;
    var suppressFocusOpen = false;

    function triggerFor(i) {
      var li = navList.children[i];
      if (!li) return null;
      return li.querySelector('a.header__menu-item') || li.querySelector('summary');
    }

    function setExpanded(i, expanded) {
      Array.prototype.forEach.call(navList.children, function (li, idx) {
        var trigger = triggerFor(idx);
        if (!trigger) return;
        var hasPane = false;
        panes.forEach(function (p) {
          if (p.getAttribute('data-index') === String(idx)) hasPane = true;
        });
        if (hasPane) {
          trigger.setAttribute('aria-haspopup', 'true');
          trigger.setAttribute('aria-controls', 'LgMegaPanel');
        }
        trigger.setAttribute('aria-expanded', expanded && idx === i ? 'true' : 'false');
      });
    }

    function visiblePane() {
      var found = null;
      panes.forEach(function (p) {
        if (!p.hidden) found = p;
      });
      return found;
    }

    function firstPaneLink() {
      var pane = visiblePane();
      if (!pane) return null;
      return pane.querySelector('.lg-mega__col-title, .lg-mega__link, .lg-mega__card-btn');
    }

    function place() {
      var h = document.querySelector('header.header') || document.querySelector('.section-header');
      var b = h ? h.getBoundingClientRect().bottom : 150;
      wrap.style.top = Math.max(b, 0) + 'px';
    }
    // 76.10 - anchor a wide pane under its own nav link. The panel is ONE
    // shared element, so the offset rides on the pane: its centre is put on
    // the hovered link's centre, then clamped so the box never crosses either
    // 4rem page gutter. At 1440 that pins Couches (1254px wide) against the
    // left gutter and lets Dining (690px) centre under DINING.
    // Compact panes already place themselves through --lg-compact-left in
    // showPane and are skipped here.
    // Called AFTER open(), never from showPane: activate() runs showPane while
    // the panel can still be hidden, and a pane inside a display:none panel
    // measures 0 wide, which would centre every pane on the gutter.
    var LG_PANE_GUTTER = 40;
    function placePane() {
      var pane = visiblePane();
      if (!pane || pane.classList.contains('lg-mega__pane--compact')) return;
      var trigger = triggerFor(activeIndex);
      if (!trigger) {
        pane.style.removeProperty('--lg-pane-left');
        return;
      }
      var t = trigger.getBoundingClientRect();
      var w = pane.offsetWidth;
      var vw = document.documentElement.clientWidth;
      var left = t.left + t.width / 2 - w / 2;
      var max = vw - LG_PANE_GUTTER - w;
      if (left > max) left = max;
      if (left < LG_PANE_GUTTER) left = LG_PANE_GUTTER;
      pane.style.setProperty('--lg-pane-left', Math.round(left - LG_PANE_GUTTER) + 'px');
    }
    function showPane(i) {
      var found = false;
      panes.forEach(function (p) {
        var match = p.getAttribute('data-index') === String(i);
        p.hidden = !match;
        if (!match) return;
        found = true;
        if (p.classList.contains('lg-mega__pane--compact')) {
          var trigger = navList.children[i];
          var offset = trigger
            ? trigger.getBoundingClientRect().left - panel.getBoundingClientRect().left
            : 0;
          p.style.setProperty('--lg-compact-left', Math.max(offset, 0) + 'px');
        } else {
          p.style.removeProperty('--lg-compact-left');
        }
      });
      return found;
    }
    function open() {
      keepOpen = true;
      if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
      place();
      panel.hidden = false;
      panel.setAttribute('aria-hidden', 'false');
      panel.classList.add('lg-mega-open');
      setExpanded(activeIndex, true);
    }
    function close() {
      if (keepOpen) return;
      panel.classList.remove('lg-mega-open');
      panel.hidden = true;
      panel.setAttribute('aria-hidden', 'true');
      panes.forEach(function (p) { p.hidden = true; });
      setExpanded(-1, false);
      activeIndex = -1;
      closeTimer = null;
    }
    function scheduleClose() {
      keepOpen = false;
      if (closeTimer) clearTimeout(closeTimer);
      closeTimer = setTimeout(close, 180);
    }
    function activate(i) {
      if (!showPane(i)) {
        scheduleClose();
        return false;
      }
      activeIndex = i;
      lastTrigger = triggerFor(i);
      open();
      placePane();
      return true;
    }

    Array.prototype.forEach.call(navList.children, function (li, i) {
      li.addEventListener('pointerenter', function () {
        activate(i);
      });
      li.addEventListener('focusin', function () {
        if (suppressFocusOpen) return;
        activate(i);
      });
    });

    navList.addEventListener('pointerleave', scheduleClose);
    panel.addEventListener('pointerenter', function () {
      keepOpen = true;
      if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
    });
    panel.addEventListener('pointerleave', scheduleClose);

    navList.addEventListener('keydown', function (e) {
      var target = e.target;
      if (!target || !navList.contains(target)) return;
      var li = target.closest('li');
      if (!li || li.parentElement !== navList) return;
      var i = Array.prototype.indexOf.call(navList.children, li);
      var intoPane = e.key === 'ArrowDown';
      var tabInto = e.key === 'Tab' && !e.shiftKey && panel.classList.contains('lg-mega-open');
      if (!intoPane && !tabInto) return;
      if (!activate(i)) return;
      var first = firstPaneLink();
      if (!first) return;
      if (intoPane || tabInto) {
        e.preventDefault();
        first.focus();
      }
    });

    document.addEventListener('focusin', function (e) {
      if (!panel.classList.contains('lg-mega-open')) return;
      var t = e.target;
      if (panel.contains(t)) {
        keepOpen = true;
        if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
        return;
      }
      if (navList.contains(t)) return;
      keepOpen = false;
      close();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      if (!panel.classList.contains('lg-mega-open')) return;
      var active = document.activeElement;
      if (!active || !panel.contains(active)) return;
      e.preventDefault();
      if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
      keepOpen = false;
      var trigger = lastTrigger || triggerFor(activeIndex);
      close();
      if (!trigger) return;
      suppressFocusOpen = true;
      trigger.focus();
      suppressFocusOpen = false;
    });
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'visible') {
        if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
        if (!keepOpen) close();
      }
    });
    window.addEventListener('scroll', function () {
      if (panel.classList.contains('lg-mega-open')) place();
    }, { passive: true });
    // Re-anchor on resize, measured on the next frame rather than inline: a
    // resize handler can run before the header has re-laid out, and placePane
    // would then read a stale trigger rect. Verified 1920 -> 1700 with the
    // pointer parked inside the panel, which is the only way to test this -
    // with the pointer over the nav, shrinking the viewport slides the nav
    // under a stationary cursor and pointerenter legitimately opens whichever
    // item is now beneath it, so the pane changes for real reasons.
    window.addEventListener('resize', function () {
      if (!panel.classList.contains('lg-mega-open')) return;
      requestAnimationFrame(placePane);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
